import { createContext, useContext } from "react";
import type { User } from "./session";

// Browser identity comes from the server session; no OAuth tokens reach React.
export interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
  signin: () => Promise<void>;
  signout: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return ctx;
}

export function userGroups(user: User | null): string[] {
  if (!user) return [];
  const groups = user.profile["groups"];
  return Array.isArray(groups) ? (groups as string[]) : [];
}

export function hasGroup(user: User | null, group: string): boolean {
  return userGroups(user).includes(group);
}

export function userDisplayName(user: User | null): string {
  if (!user) return "";
  const profile = user.profile as Record<string, unknown>;
  return (
    (profile["preferred_username"] as string | undefined) ??
    (profile["name"] as string | undefined) ??
    (profile["sub"] as string | undefined) ??
    "user"
  );
}
